function formatNumberWithConsecutiveZeros(number) {
  if (!number) {
    return;
  }
  const [integerPart, decimalPart] = number?.toString()?.split(".") || [];

  let zeroCount = 0;
  let remainingZeros = "";

  if (decimalPart !== undefined) {
    var trimmedDecimal = decimalPart.replace(/^0+/, "");
    zeroCount = decimalPart.length - trimmedDecimal.length;
    remainingZeros =
      zeroCount > 1 ? (
        <span className="text-2xs font-bold">{zeroCount}</span>
      ) : (
        ""
      );
  }

  return (
    <div>
      {`${integerPart}.0`}
      {remainingZeros !== null && remainingZeros}
      {`${trimmedDecimal?.slice(0, 4) || "0"}`}
    </div>
  );
}

const FormattedNumber = ({ number }) => {
  const formattedNumber = formatNumberWithConsecutiveZeros(number);
  if (formattedNumber === undefined) {
    return <span className="text-xs text-n-40">N/A</span>;
  } else {
    return <span className="flex">${formattedNumber}</span>;
  }
};

export default FormattedNumber;
